export default __webpack_public_path__ + "icon-video5f4273.png";